<span class="tab-button nav-chevron nav-chevron-left" [class.visible]="showLeft" (click)="scrollLeft()">
	<app-icon name="chevron-left" color="primary-1"></app-icon>
</span>
<section #viewport>
	<div>
		@for (menuItem of appMenuService.tabMenu(); track menuItem.name) {
			<a
				[routerLink]="getUrl(menuItem)"
				[queryParams]="menuItem.queryParams"
				[queryParamsHandling]="menuItem.queryParamsHandling"
				routerLinkActive="active"
			>
				{{ menuItem.name }}
			</a>
		}
	</div>
</section>
<span class="tab-button nav-chevron nav-chevron-right" [class.visible]="showRight" (click)="scrollRight()">
	<app-icon name="chevron-right" color="primary-1"></app-icon>
</span>
<ng-content></ng-content>
